/**
 * Created by Victor Rojo on 30/8/19.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import { Tag, ItemTag } from "./Tag";

@Injectable()
export class TagService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  get(itemType:number): Promise<any>{
    let url = this.basePath + "tag";
    let params = new HttpParams();
    params = params.append('type', itemType.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as Tag[])
      .catch( error => this.errorHandler(error) );
  }

  getItemTags(itemType:number): Promise<any>{
    let url = this.basePath + "tag/item";
    let params = new HttpParams();
    params = params.append('type', itemType.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as ItemTag[])
      .catch( error => this.errorHandler(error) );
  }

}
